var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useLayoutEffect, useState } from 'react';
export var useWindowSize = function () {
    var _a = useState([0, 0]), size = _a[0], setSize = _a[1];
    useLayoutEffect(function () {
        var updateSize = function () {
            setSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', updateSize);
        updateSize();
        return function () { return window.removeEventListener('resize', updateSize); };
    }, []);
    return __spreadArray([], size); // [w,h]
};
